import { Label } from '@kcftech/design-system';
import { ValidatableLabel } from 'components/forms/ValidatableLabel';
import { useFormContext, useFormState } from 'react-hook-form';
import { AlarmThresholdFormFields } from './shared';
import {
    NotificationCriteriaWrapper,
    OfContainer,
    PercentageInput,
    SecondaryText,
    StyledCard,
    StyledNumberInput,
} from './styled';
import {
    percentageFieldRules,
    pointsFieldRules,
    validateNotificationCriteria,
} from './validation';

export function NotificationCard() {
    const { register, control } = useFormContext<AlarmThresholdFormFields>();
    const { errors } = useFormState({ control });

    return (
        <StyledCard className="flex-column gap-10">
            <Label label="NOTIFICATION CRITERIA" />
            <NotificationCriteriaWrapper>
                <ValidatableLabel label="Percentage" error={errors.percentage} required>
                    <div className="flex-row align-center gap-5">
                        <PercentageInput
                            {...register('percentage', {
                                ...percentageFieldRules,
                                setValueAs: (v) => (typeof v === 'string' ? v.trim() : v),
                                validate: (value) =>
                                    validateNotificationCriteria(value, 'percent'),
                            })}
                            invalid={Boolean(errors.percentage)}
                            placeholder="Enter percentage"
                        />
                        <SecondaryText>%</SecondaryText>
                    </div>
                </ValidatableLabel>
                <OfContainer>
                    <span className="bold">of</span>
                </OfContainer>
                <div className="flex-row align-flex-start gap-5">
                    <ValidatableLabel label="Points" error={errors.points} required>
                        <StyledNumberInput
                            {...register('points', {
                                ...pointsFieldRules,
                                setValueAs: (v) => (typeof v === 'string' ? v.trim() : v),
                                validate: (value) =>
                                    validateNotificationCriteria(value, 'points'),
                            })}
                            invalid={Boolean(errors.points)}
                            placeholder="Enter points"
                        />
                    </ValidatableLabel>
                </div>
            </NotificationCriteriaWrapper>
        </StyledCard>
    );
}
